import React from 'react';

const Icon = ({ size = '81', fill = '#FFCF47', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 81 81" fill="none" {...other}>
            <path
                d="M50.995 25.03H25.582a2.253 2.253 0 1 1 0-4.494h25.413a2.253 2.253 0 0 1 0 4.493Zm0 16.466H25.582a2.254 2.254 0 1 1 0-4.493h25.413a2.254 2.254 0 0 1 0 4.493Zm-8.987 16.453H25.582a2.24 2.24 0 1 1 0-4.48h16.426a2.24 2.24 0 1 1 0 4.48Zm18.36-9.226a13.333 13.333 0 1 0 0 26.666 13.333 13.333 0 0 0 0-26.666Zm5.854 11.84a1.173 1.173 0 0 1-1.174 1.173h-3.08v2.027h3.08a1.173 1.173 0 0 1 1.174 1.16v.106a1.174 1.174 0 0 1-1.174 1.174h-3.08v1.813a1.494 1.494 0 0 1-2.986 0v-1.813h-3.294a1.16 1.16 0 0 1-1.16-1.174v-.106a1.16 1.16 0 0 1 1.16-1.16h3.294v-2h-3.294a1.16 1.16 0 0 1-1.16-1.174 1.16 1.16 0 0 1 1.16-1.16h1.494l-1.6-3a1.334 1.334 0 0 1 1.146-1.933h.227a1.333 1.333 0 0 1 1.133.653l2.387 4.134 2.28-4.107a1.333 1.333 0 0 1 2.307 1.253l-1.614 2.974h1.6a1.173 1.173 0 0 1 1.174 1.16Z"
                fill={fill}
            />

            <path
                d="M44.248 74.417H15.075a8.307 8.307 0 0 1-8.24-8.227V13.763a8.32 8.32 0 0 1 8.24-8.24h46.4a8.307 8.307 0 0 1 8.227 8.24V44.43a2.253 2.253 0 0 1-4.494 0V13.763a3.706 3.706 0 0 0-3.733-3.746h-46.4a3.72 3.72 0 0 0-3.747 3.746V66.19a3.706 3.706 0 0 0 3.747 3.733h29.173a2.253 2.253 0 0 1 0 4.494Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
